export const level2amount = { 1: 12.99, 2: 29.99 };

export const recaptcha_public_key = '6LfEAdMUAAAAAHgb6ZOINv232vzEtuMKp4v4GCR-';

export const siteUrl = 'https://secresilk.spearmintlabs.org';